module.exports = __webpack_public_path__ + "img/maestro.0db25a0e.svg";